import "./planpagelayout.css";
import { Plan } from "./plan";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";
import { useHistory } from "react-router-dom";
import { PayHeader } from "../Paymentheader/PayHeader";
import { EditOutlined, DownOutlined } from "@ant-design/icons";
import { Modal, Dropdown, Space } from "antd/lib";
import MemberEditTabs from "./MemberTab";
import MultiYearHeath from "./MultiYear";
import PlanTypeHeath from "./PlanTypeHealth";
import CoverEditHeath from "./CoverEdit";
import InsurerFilter from "./InsurerFilter";
import ShareQImage from "../../assets/share quote.png";
// import SendToCustomer from "./SendToCustomer";

function PlanLayout3() {
  const dispatch = useDispatch();
  const history = useHistory();
  const QuickQuotes = useSelector((state) => state?.healthdetail?.quickquotes);
  const QuickQuotePost = useSelector(
    (state) => state?.healthdetail?.QuickQuotePost
  );
  const QuoteInput = useSelector((state) => state?.healthdetail?.quoteInput);
  const bikeMakedata = useSelector((state) => state?.healthdetail?.carMakeData);
  const FamDetails = useSelector(
    (state) => state?.healthdetail?.famdetail?.healthdetail
  );
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [ModelOpenMember, setIsModalOpenMember] = useState(false);
  const [isModalInsurer, setisModalInsurer] = useState(false);
  const [isModalPlanType, setisModalPlanType] = useState(false);
  const [isModalMultiyr, setisModalMultiYr] = useState(false);
  const [isModalCover, setisModalCover] = useState(false);
  const [isModalSendPdf, setisModalSendPdf] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const shortlistedQuotesLength = QuickQuotes?.filter(
    (quote) => quote?.selected
  )?.length;

  // console.log(FamDetails)
  const handleScroll = () => {
    if (window.scrollY > 80) {
      setScrolled(true);
      // console.log(scrolled);
    } else {
      setScrolled(false);
      // console.log(scrolled);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // console.log("after dispatch", temp);
  const policyTypeClick = () => {
    setIsModalOpen(true);
  };
  const HandleInsurer = () => {
    setisModalInsurer(true);
  };
  const HandlePlanType = () => {
    setisModalPlanType(true);
  };
  const HandleMultiYr = () => {
    setisModalMultiYr(true);
  };
  const HandleMember = () => {
    setIsModalOpenMember(true);
  };
  const HandleCover = () => {
    setisModalCover(true);
  };
  const handleCancelMem = () => {
    setIsModalOpenMember(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };
  const handleCancelInsurer = () => {
    setisModalInsurer(false);
  };
  const handleCancelPlanType = () => {
    setisModalPlanType(false);
  };
  const handleCancelMulYr = () => {
    setisModalMultiYr(false);
  };
  const handleCancelCover = () => {
    setisModalCover(false);
  };
  const handleCancelPdf = () => {
    setisModalSendPdf(false);
  };
  const items = [
    {
      label: "All Quotes",
      key: "0",
    },
    {
      label: "Shortlisted Quote",
      key: "1",
      disabled: shortlistedQuotesLength === 0,
    },
  ];
  const onClick = ({ key }) => {
    console.log(key);
    if (key === "0") {
      setisModalSendPdf(true);
    }
  };
  return (
    <div>
      <PayHeader />
      <div className={scrolled ? `sticky-health` : `health-detail-head`}>
        <div className="healthinner-t">
          <div className="inner-f-health">
            <div className="d-flex align-items-center">
              <div className="H-border"></div>
              <div className="health-e">Edit Details</div>
              <div className="d-health-icon">
                <EditOutlined
                  key="save"
                  style={{ cursor: "pointer" }}
                  onClick={HandleMember}
                />
              </div>
              {/* <div className="health-edit-Det">
                      {FamDetails?.map((famdetail, i) => ({
                        key: i + 1,
                        value: famdetail,
                        label: famdetail,
                      }))
                        .map((mappedFam, i, array) => (
                          <div key={i + 1}>
                            {mappedFam.label}
                            {mappedFam.label.length > 1 && i !== array.length - 1 && ','}
                          </div>
                        ))}
                    </div> */}
              <div className="health-edit-Det">
                {FamDetails?.map((item, index) => (
                  <div key={index}>
                    {item.relationship}
                    {index !== FamDetails?.length - 1 && ","}
                  </div>
                ))}
              </div>
            </div>
            <div className="health-share">
              <img src={ShareQImage} style={{ width: "25px" }}></img>
              <span>
                <Dropdown
                  menu={{
                    items,
                    onClick,
                  }}
                  trigger={["click"]}
                  placement="bottomLeft"
                >
                  <a onClick={(e) => e.preventDefault()}>
                    <Space>Share Quotes</Space>
                  </a>
                </Dropdown>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className={`editquote-health`}>
        {/* <div className="row justify-content-center"> */}
        <div className="edit-q-heal-inner">
          <p className="editbike mb-0">More Filters</p>
          <p className="mb-0">
            Select Filters
            <EditOutlined
              key="save"
              style={{ cursor: "pointer" }}
              onClick={policyTypeClick}
            />
          </p>
        </div>
        <div className="edit-q-heal-inner">
          <p className="editbike mb-0">Cover</p>
          <p className="mb-0">
            {/* {QuickQuotePost?.suminsured === "500000" ? 'Upto 5Lakhs' : QuickQuotePost?.suminsured} */}
            {QuickQuotePost?.suminsured === "300000"
              ? "Upto 3 Lakhs"
              : QuickQuotePost?.suminsured === "500000"
              ? "Upto 5Lakhs"
              : QuickQuotePost?.suminsured === "750000"
              ? "Upto 7.5 Lakhs"
              : QuickQuotePost?.suminsured === "1000000"
              ? "Upto 10 Lakhs"
              : QuickQuotePost?.suminsured === "1500000"
              ? "Upto 15 Lakhs"
              : QuickQuotePost?.suminsured === "2000000"
              ? "Upto 20 Lakhs"
              : QuickQuotePost?.suminsured === "2500000"
              ? "Upto 25 Lakhs"
              : QuickQuotePost?.suminsured === "5000000"
              ? "Upto 50 Lakhs"
              : QuickQuotePost?.suminsured === "7500000"
              ? "Upto 75 Lakhs"
              : QuickQuotePost?.suminsured === "10000000"
              ? "Upto 1 Crore"
              : ""}
            <DownOutlined
              key="save"
              style={{ cursor: "pointer" }}
              onClick={HandleCover}
            />
          </p>
        </div>
        <div className="edit-q-heal-inner">
          <p className="editbike mb-0">Multiyear Option</p>
          <p className="mb-0">
            {QuickQuotePost?.policyPeriod === 1
              ? "1 Year"
              : QuickQuotePost?.policyPeriod === 2
              ? "2 Years"
              : QuickQuotePost?.policyPeriod === 3
              ? "3 Years"
              : "Select Filters"}

            <EditOutlined
              key="save"
              style={{ cursor: "pointer" }}
              onClick={HandleMultiYr}
            />
          </p>
        </div>
        <div className="edit-q-heal-inner">
          <p className="editbike mb-0">Plan Type</p>
          <p className="mb-0">
            Select Filters
            <EditOutlined
              key="save"
              style={{ cursor: "pointer" }}
              onClick={HandlePlanType}
            />
          </p>
        </div>
        <div className="edit-q-heal-inner">
          <p className="editbike mb-0">Insurers</p>
          <p className="mb-0">
            Select Insurers
            <EditOutlined
              key="save"
              style={{ cursor: "pointer" }}
              onClick={HandleInsurer}
            />
          </p>
        </div>
        {/* </div> */}
      </div>
      <Plan />
      <Modal
        title="please choose the way you wish to share the quotes."
        open={isModalSendPdf}
        // footer={null}
        footer="* Please note that the premium may vary in future."
        onCancel={handleCancelPdf}
        maskClosable={false}
      >
        {/* <SendToCustomer setisModalSendPdf={setisModalSendPdf} isModalSendPdf={isModalSendPdf}/> */}
      </Modal>
      <Modal
        title="Edit Member Details"
        open={ModelOpenMember}
        footer={null}
        onCancel={handleCancelMem}
        maskClosable={false}
      >
        <MemberEditTabs setIsModalOpenMember={setIsModalOpenMember} />
      </Modal>
      <Modal
        title="More Filters"
        open={isModalOpen}
        footer={null}
        onCancel={handleCancel}
        maskClosable={false}
      >
        {/* <CarPrevpolictype setIsModalOpen={setIsModalOpen} /> */}
      </Modal>
      <Modal
        title="Plan Type"
        open={isModalPlanType}
        footer={null}
        onCancel={handleCancelPlanType}
        maskClosable={false}
      >
        <PlanTypeHeath setisModalPlanType={setisModalPlanType} />
      </Modal>
      <Modal
        title="Multiyear Options"
        open={isModalMultiyr}
        footer={null}
        onCancel={handleCancelMulYr}
        maskClosable={false}
      >
        <MultiYearHeath setisModalMultiYr={setisModalMultiYr} />
      </Modal>
      <Modal
        title="Cover Range"
        className="Health-Modal"
        open={isModalCover}
        footer={null}
        onCancel={handleCancelCover}
        maskClosable={false}
      >
        <CoverEditHeath setisModalCover={setisModalCover} />
      </Modal>
      <Modal
        title="Insurers"
        open={isModalInsurer}
        footer={null}
        onCancel={handleCancelInsurer}
        maskClosable={false}
      >
        <InsurerFilter setisModalInsurer={setisModalInsurer} />
      </Modal>
    </div>
  );
}

export { PlanLayout3 };
